import { id } from "element-plus/es/locales.mjs";

let menuList = {
  SW: [
    {
      id: 1000,
      title: "t_qylb",
      icon: "el-icon-home",
      path: "/factory/index",
      permission: "home:SWIndex",
    },
    {
      id: 3000,
      title: "t_bddzje",
      icon: "el-icon-yuanliaocangfengbao",
      path: "/factory/waste",
      permission: "waste",
      children: [
        {
          id: 3100,
          title: "t_cv6g5l",
          path: "/factory/waste/feeding",
          permission: "waste:deliveryDetail",
        },
        {
          id: 3150,
          title: "t_fgikf",
          name: "waste/storage",
          path: "/factory/waste/storage",
          permission: "waste:storageDetail",
        },
        {
          id: 3160,
          title: "t_cdqh3",
          name: "waste/orderIn",
          path: "/factory/waste/orderIn",
          permission: "waste:orderIn",
        },
        {
          id: 3170,
          title: "t_cgsyk",
          name: "waste/orderOut",
          path: "/factory/waste/orderOut",
          permission: "waste:orderOut",
        },
        {
          id: 3180,
          title: "t_acd50l",
          name: "waste/bration",
          path: "/factory/waste/bration",
          permission: "waste:facilityCorrect",
        },
        {
          id: 3200,
          title: "t_exrdp",
          name: "waste/deliveryCode",
          path: "/factory/waste/deliveryCode",
          permission: "waste:deliveryCode",
        },
        {
          id: 3220,
          title: "t_j90e7i",
          name: "waste/destroyCert",
          path: "/factory/waste/destroyProve",
          permission: "waste:destroyProve",
        },
        {
          id: 3230,
          title: "t_abq7ot",
          name: "waste/project",
          path: "/factory/waste/project",
          permission: "waste:deliveryExtend",
        },
      ],
    },
    {
      id: 3300,
      title: "t_gl4wvs",
      icon: "el-icon-message",
      path: "/factory/settle",
      permission: "settle",
      children: [
        {
          id: 3310,
          title: "t_em0oo",
          path: "/factory/settle/wait",
          permission: "settle:wait",
        },
        {
          id: 3320,
          title: "t_j97gi",
          path: "/factory/settle/complete",
          permission: "settle:complete",
        },
      ],
    },
    {
      id: 3900,
      title: "t_d7k0js",
      icon: "el-icon-message",
      path: "/factory/analysis",
      permission: "waste:summary",
      children: [
        {
          id: 3910,
          title: "t_abe59e",
          path: "/factory/analysis/dataAnalysis",
          permission: "waste:summary:produce",
        },
        {
          id: 3940,
          title: "t_cbfbev",
          path: "/factory/analysis/stockStat",
          permission: "waste:summary:stockStat",
        },
        {
          id: 3920,
          title: "t_gd98ey",
          path: "/factory/analysis/output",
          permission: "waste:summary:output",
        },
        {
          id: 3930,
          title: "t_abfz7c",
          path: "/factory/analysis/auditStat",
          permission: "waste:summary:auditStat",
        },
        {
          id: 3950,
          title: "t_d7l48s",
          path: "/factory/analysis/dashboard",
          permission: "waste:summary:dashboard",
        },
      ],
    },
    {
      id: 4000,
      title: "t_exe2mc",
      icon: "el-icon-yuanliaocangfengbao",
      path: "/factory/ledger",
      permission: "ledger",
      children: [
        {
          id: 4100,
          title: "t_6heg3y",
          path: "/factory/ledger/produceList",
          permission: "ledger:produceList",
        },
        {
          id: 4200,
          title: "t_tp4z2m",
          path: "/factory/ledger/flowDirection",
          permission: "ledger:flowDirection",
        },
        {
          id: 4300,
          title: "t_kw9cdf",
          path: "/factory/ledger/factoryLink",
          permission: "ledger:factoryLink",
        },
        {
          id: 4400,
          title: "t_c4yxjn",
          path: "/factory/ledger/produceLink",
          permission: "ledger:produceLink",
        },
      ],
    },
    {
      id: 5000,
      title: "t_gar1ro",
      icon: "el-icon-peizhi",
      path: "/factory/setting",
      permission: "setting",
      children: [
        {
          id: 5100,
          title: "t_f6y6dw",
          path: "/factory/setting/user",
          permission: "setting:sysUser",
        },
        {
          id: 5200,
          title: "t_ybmfxk",
          path: "/factory/setting/psa",
          permission: "setting:psaMap",
        },
        {
          id: 5300,
          title: "t_rkezlu",
          path: "/factory/setting/linked",
          permission: "setting:psaCardMap",
        },
        {
          id: 5400,
          title: "t_dgdz62",
          path: "/factory/setting/material",
          permission: "setting:mapMaterialWaste",
        },
      ],
    },
  ],
  HW: [
    {
      id: 1000,
      title: "t_qylb",
      icon: "el-icon-shouye",
      path: "/hazardous/index",
      permission: "home:HWIndex",
    },
    {
      id: 2000,
      title: "t_de8uz9",
      icon: "el-icon-yuanliaocangfengbao",
      path: "/hazardous/collect",
      permission: "hw:collect",
      children: [
        {
          id: 2100,
          title: "t_debh85",
          icon: "el-icon-fanganguanli",
          path: "/hazardous/collect/record",
          permission: "hw:collect:detail",
        },
        {
          id: 2300,
          title: "t_ee40r7",
          icon: "el-icon-fanganguanli",
          path: "/hazardous/collect/flowRecord",
          permission: "hw:flow",
        },
        {
          id: 2200,
          title: "t_de3s6t",
          icon: "el-icon-fanganguanli",
          path: "/hazardous/collect/stock",
          permission: "hw:collect:stock",
        },
      ],
    },
    {
      id: 500050,
      title: "t_b6ejwb",
      icon: "el-icon-yuanliaocangfengbao",
      path: "/hazardous/waste",
      permission: "hw",
      children: [
        {
          id: 2900,
          title: "t_ce8j3j",
          icon: "el-icon-kehuguanli",
          path: "/hazardous/waste/waitDelivery",
          permission: "hw:waitDelivery",
        },
        {
          id: 3900,
          title: "t_virtualLabel",
          icon: "el-icon-kehuguanli",
          path: "/hazardous/waste/virtualLabel",
          permission: "hw:virtualDelivery",
        },
        {
          id: 3000,
          title: "t_ibpjc4",
          icon: "el-icon-kehuguanli",
          path: "/hazardous/waste/delivery",
          permission: "hw:delivery",
        },
        {
          id: 3900,
          title: "t_i2k6jy",
          icon: "el-icon-fanganguanli",
          path: "/hazardous/waste/storageIn",
          permission: "hw:storageIn",
        },
        {
          id: 4000,
          title: "t_hzx1ib",
          icon: "el-icon-fuwuguanli",
          path: "/hazardous/waste/storageOut",
          permission: "hw:storageOut",
        },
        {
          id: 500400,
          title: "t_hqlopt",
          icon: "el-icon-fuwuguanli",
          path: "/hazardous/waste/dispose",
          permission: "hw:storageUse",
        },
        {
          id: 500050,
          title: "t_g30nh2",
          icon: "el-icon-fuwuguanli",
          path: "/hazardous/waste/plan",
          permission: "hw:plan",
        },
        {
          id: 500060,
          title: "t_d0vlez",
          icon: "el-icon-fuwuguanli",
          path: "/hazardous/waste/storageCorrect",
          permission: "hw:storageCorrect",
        },
        {
          id: 500070,
          title: "t_returnToStorage",
          icon: "el-icon-fuwuguanli",
          path: "/hazardous/waste/backStore",
          permission: "hw:scanBack",
        },
      ],
    },
    {
      id: 3200,
      title: "t_iloxjo",
      icon: "el-icon-message",
      path: "/hazardous/transfer",
      permission: "hw:transfer",
      children: [
        {
          id: 3210,
          title: "t_eoqj8",
          path: "/hazardous/transfer/waitList",
          permission: "hw:transfer:wait",
        },
        {
          id: 3220,
          title: "t_ilpjv4",
          path: "/hazardous/transfer/transferRecord",
          permission: "hw:transfer:record",
        },
        {
          id: 3220,
          title: "t_ordModConf",
          path: "/hazardous/transfer/transferChange",
          permission: "hw:transfer:change",
        },
        {
          id: 3220,
          title: "退单退货",
          path: "/hazardous/transfer/transferBack",
          permission: "hw:transfer:back",
        },
      ],
    },
    {
      id: 3300,
      title: "t_gl4wvs",
      icon: "el-icon-message",
      path: "/hazardous/settle",
      permission: "hw:settle",
      children: [
        {
          id: 3310,
          title: "t_em0oo",
          path: "/hazardous/settle/wait",
          permission: "hw:settle:wait",
        },
        {
          id: 3320,
          title: "t_j97gi",
          path: "/hazardous/settle/complete",
          permission: "hw:settle:complete",
        },
      ],
    },
    {
      id: 507000,
      title: "t_d7k0js",
      icon: "el-icon-message",
      path: "/hazardous/analysis",
      permission: "hw:summary",
      children: [
        {
          id: 507100,
          title: "t_i2e5",
          icon: "el-icon-kehuguanli",
          path: "/hazardous/analysis/monthReport",
          permission: "hw:summary:monthReport",
        },
        {
          id: 507200,
          title: "t_g336",
          icon: "el-icon-kehuguanli",
          path: "/hazardous/analysis/quarterReport",
          permission: "hw:summary:quarterReport",
        },
        {
          id: 507300,
          title: "t_glv5",
          icon: "el-icon-kehuguanli",
          path: "/hazardous/analysis/yearReport",
          permission: "hw:summary:yearReport",
        },
        {
          id: 507400,
          title: "t_d7l48s",
          path: "/hazardous/analysis/dashboard",
          permission: "hw:summary:dashboard",
        },
      ],
    },
    {
      id: 508000,
      title: "t_gar1ro",
      icon: "el-icon-peizhi",
      path: "/hazardous/setting",
      permission: "setting",
      children: [
        {
          id: 500500,
          title: "t_vg50rs",
          icon: "el-icon-fuwuguanli",
          path: "/hazardous/setting/facility",
          permission: "setting:deliveryFacility",
        },
        {
          id: 508200,
          title: "t_tt22yx",
          icon: "el-icon-fuwuguanli",
          path: "/hazardous/setting/useFacility",
          permission: "setting:useFacility",
        },
        {
          id: 508300,
          title: "t_dwck2y",
          icon: "el-icon-fuwuguanli",
          path: "/hazardous/setting/storageFacility",
          permission: "setting:storageFacility",
        },
        {
          id: 508400,
          title: "t_h0dy46",
          icon: "el-icon-fuwuguanli",
          path: "/hazardous/setting/receive",
          permission: "setting:transfer",
        },
      ],
    },
    {
      id: 509000,
      title: "t_jwlm9p",
      icon: "el-icon-peizhi",
      path: "/hazardous/riskAlert/list",
      permission: "hw:riskAlert",
    },
  ],
};

export default menuList;
